import { render } from "./AllNewsView.vue?vue&type=template&id=f0f7c74c"
import script from "./AllNewsView.vue?vue&type=script&lang=js"
export * from "./AllNewsView.vue?vue&type=script&lang=js"

import "./AllNewsView.vue?vue&type=style&index=0&id=f0f7c74c&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__